<ion-modal
  id="popupModal"
  [isOpen]="isOpen"
  [showBackdrop]="true"
  [backdropDismiss]="canClose"
  (didDismiss)="onClose.emit()"
>
  <ng-template>
    <div class="wrapper">
      <div class="header">
        <ion-icon *ngIf="canClose" name="close-outline" class="header_close-btn" (click)="onClose.emit()"></ion-icon>
      </div>
      <div class="content">
        <ng-content></ng-content>
      </div>
    </div>
  </ng-template>
</ion-modal>
